require('../styles/anonymous.css');

const initializeApp = require('../runtime/init-app.cjs');

initializeApp({ anonymous: true });
